import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgUploadFail = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-error))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M52 19.07V33.5c0 8.72 0 13.081-2.71 15.79C46.582 52 42.22 52 33.5 52c-8.721 0-13.081 0-15.79-2.71C15 46.582 15 42.22 15 33.5c0-8.721 0-13.081 2.71-15.79C20.418 15 24.778 15 33.5 15h11.655"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M14 33.5c0-4.203-.003-7.506.343-10.08.352-2.618 1.09-4.705 2.73-6.346 1.642-1.642 3.729-2.379 6.346-2.731 2.575-.346 5.878-.343 10.082-.343h11.348a1.486 1.486 0 0 1 0 2.972H33.501c-4.288 0-7.355.004-9.686.317-2.288.308-3.643.89-4.64 1.886-.997.997-1.578 2.352-1.886 4.64-.313 2.33-.317 5.398-.317 9.686 0 4.287.004 7.353.317 9.684.308 2.288.89 3.643 1.886 4.64.997.997 2.352 1.578 4.64 1.886 2.33.313 5.398.317 9.686.317 4.287 0 7.353-.004 9.684-.317 2.288-.308 3.643-.89 4.64-1.886.997-.997 1.578-2.352 1.886-4.64.313-2.33.317-5.397.317-9.684V19.45a1.486 1.486 0 0 1 2.972 0V33.5c0 4.204.003 7.507-.343 10.082-.352 2.617-1.089 4.703-2.73 6.344-1.64 1.642-3.728 2.379-6.345 2.731-2.575.346-5.878.343-10.081.343-4.204 0-7.507.003-10.082-.343-2.617-.352-4.704-1.089-6.345-2.73-1.642-1.64-2.379-3.728-2.731-6.345C13.997 41.007 14 37.704 14 33.5"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M33.667 41.791a1.375 1.375 0 0 1 0 2.75h-10a1.375 1.375 0 1 1 0-2.75zm5-5.833a1.375 1.375 0 1 1 0 2.75h-15a1.375 1.375 0 1 1 0-2.75z"
      />
      <path
        fill="hsl(var(--system-icon-red))"
        d="M56 19c0 6.075-4.925 11-11 11s-11-4.925-11-11S38.925 8 45 8s11 4.925 11 11"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M47.888 14.556a1.1 1.1 0 0 1 1.557 1.554L46.555 19l2.89 2.89a1.1 1.1 0 0 1-1.557 1.556l-2.89-2.89-2.888 2.89a1.1 1.1 0 0 1-1.554-1.557l2.888-2.89-2.889-2.888a1.1 1.1 0 1 1 1.555-1.554L45 17.444z"
      />
    </svg>
  );
};
export default SvgUploadFail;
